export default class BlockPromoEditorial extends Core.BlockComponent {
  constructor(el, context) {
    super(el, context);

    this.contentWrapper = el.querySelector('[data-content-wrapper]');
    this.contentAreas = el.querySelectorAll('[data-content-area]');
  }

  get blockHeight() {
    const {
      paddingTop: containerPaddingTop,
      paddingBottom: containerPaddingBottom,
    } = getComputedStyle(this.contentWrapper);
    const paddingTopInt = Number(containerPaddingTop.replace('px', ''));
    const paddingBottomInt = Number(containerPaddingBottom.replace('px', ''));
    const height = [...this.contentAreas]
      .reduce((acc, curr) => acc + curr.offsetHeight, paddingTopInt + paddingBottomInt);
    return `${height}px`;
  }
}
